import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import CacheManager from '../../../cache/CacheManager';
import UpdateWhatsappModalUI from './UpdateWhatsappModalUI';

class UpdateWhatsappModalSF extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      phone: '',
      phoneError: null,
    };
  }

  render() {
    return (
      <UpdateWhatsappModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // Event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onUpdatePhoneCancel}
        // Modes
        updatePhoneMode={this.props.updateEmailMode}
        submitted={this.state.submitted}
        // Form fields
        phone={this.state.phone}
        onPhoneChange={(event) => this.setState({ phone: event.target.value })}
        phoneError={this.state.phoneError}
        setPhoneError={(error) => this.setState({ phoneError: error })}
      />
    );
  }

  componentDidMount() {
    Modal.setAppElement('body');
    
    if (this.props.selectedEmail) {
      this.setState({ phone: this.props.selectedEmail });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedEmail !== this.props.selectedEmail && this.props.selectedEmail) {
      this.setState({ phone: this.props.selectedEmail });
    }
  }

  onUpdatePhoneCancel = () => {
    this.setState({
      successMsg: null,
      errorList: null,
      submitted: false,
      phone: '',
      phoneError: null,
    });

    if (this.props.onUpdateEmailCancel) {
      this.props.onUpdateEmailCancel();
    }
  }

onSubmit = () => {
  if (this.state.submitted) return;

  this.setState({
    successMsg: null,
    errorList: [],
    submitted: true,
  });

  try {
    const messageApprovalId = this.props.message && this.props.message.messageApprovalId;
    if (!messageApprovalId) {
      throw new Error('Message approval ID is required');
    }
    
    const phoneToUpdate = this.props.selectedEmail;
    if (!phoneToUpdate) {
      throw new Error('Phone number to update is required');
    }
    
    // Check if the phone number has changed
    if (this.state.phone === phoneToUpdate) {
      throw new Error('The new phone number is the same as the current one');
    }

    const phoneNumbersStr = localStorage.getItem('phoneNumbers');
    const phoneNumbersMap = phoneNumbersStr ? JSON.parse(phoneNumbersStr) : {};
    
    const messagePhones = phoneNumbersMap[messageApprovalId] || [];
    
    // Check if the new phone number already exists in the list (excluding the one being updated)
    const isDuplicate = messagePhones.some((phone, idx) => {
      const currentIndex = messagePhones.indexOf(phoneToUpdate);
      return phone === this.state.phone && idx !== currentIndex;
    });
    
    if (isDuplicate) {
      throw new Error('This phone number already exists in the recipient list');
    }
    
    const index = messagePhones.indexOf(phoneToUpdate);
    if (index !== -1) {
      messagePhones[index] = this.state.phone;
      
      phoneNumbersMap[messageApprovalId] = messagePhones;
      
      CacheManager.setObject('phoneNumbers', phoneNumbersMap);
      
      this.setState({
        successMsg: 'Phone number updated successfully',
        submitted: false,
      });

      setTimeout(() => {
        this.setState({ 
          successMsg: null,
          phone: '' 
        });
        
        if (this.props.onUpdateEmailCancel) {
          this.props.onUpdateEmailCancel();
        }
        
        if (this.props.onRefreshClick) {
          this.props.onRefreshClick();
        }
      }, 2000);
    } else {
      throw new Error('Phone number not found');
    }
  } catch (error) {
    this.setState({
      errorList: [error.message || 'Failed to update phone number'],
      submitted: false,
    });
  }
}

  setErrorList = (errorList) => {
    this.setState({ errorList });
  };
}

export default withRouter(UpdateWhatsappModalSF);